<template>
  <div class="jobs" style="min-height: calc(100vh - 200px)">
    <div class="row">
      <div class="col">
        <h2 class="h4 font-weight-normal font-sans-serif-light">FILTROS</h2>
      </div>

      <div class="col d-flex justify-content-end" style="min-height: 40px">
        <FiltersBadges
          :jobName="jobName"
          @resetJobName="
            jobName = null;
            typingJobName = null;
          "
          :selectedStates="selectedState ? [selectedState] : []"
          @resetState="selectedState = null"
          :selectedCities="selectedCity ? [selectedCity] : []"
          @resetCity="selectedCity = null"
          :selectedLevel="selectedLevel"
          @resetLevel="selectedLevel = null"
          :selectedPCD="selectedPCD"
          @resetPCD="selectedPCD = false"
          :selectedTeam="selectedTeam"
          @resetTeam="selectedTeam = null"
        />
      </div>
    </div>

    <div class="row mt-2 align-items-center">
      <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <selectize
          :settings="stateSettings"
          v-model="selectedState"
          class="rounded-xl font-sans-serif-regular"
          placeholder="Estado"
        >
          <option
            :value="state.abbr"
            v-for="(state, index) in states"
            :key="index"
          >
            {{ state.name }}
          </option>
        </selectize>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <selectize
          :settings="citySettings"
          v-model="selectedCity"
          class="rounded-xl font-sans-serif-regular text-capitalize"
          placeholder="Cidade"
        >
          <option
            :value="city.cidade"
            v-for="(city, index) in cities"
            :key="index"
          >
            {{ city.cidade }}
          </option>
        </selectize>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <selectize
          :settings="levelSettings"
          v-model="selectedLevel"
          class="rounded-xl font-sans-serif-regular"
          placeholder="Nível"
        >
          <option
            :value="level.id"
            v-for="(level, index) in levels"
            :key="index"
          >
            {{ level.name }}
          </option>
        </selectize>
      </div>

      <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div
          class="
            custom-control
            custom-checkbox
            custom-checkbox-lg
            custom-checkbox-background
            font-sans-serif-regular
            small
          "
        >
          <input
            type="checkbox"
            class="custom-control-input"
            id="is-pcd"
            v-model="selectedPCD"
          />
          <label class="custom-control-label" for="is-pcd"
            >Pessoa com Deficiência</label
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <form v-on:submit.prevent="submitJobName()" novalidate>
          <div class="input-group">
            <input
              type="text"
              v-model="typingJobName"
              class="
                form-control
                rounded-xl
                border
                font-sans-serif-regular
                border-right-0
              "
              placeholder="Busque pelo nome da vaga"
              style="height: auto"
            />
            <div class="input-group-append">
              <button
                class="
                btn btn-white
                border
                rounded-xl
                border-left-0
                "
                type="button"
                @click="submitJobName()"
              >
                <magnify-icon class="h4 my-1 text-muted" />
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row mt-5">
      <JobBox
        :opportunity="opportunity"
        v-for="(opportunity, id) in opportunities"
        :key="id"
        :id="id"
        :btnSubscriptionText="'QUERO ME INSCREVER!'"
        :showDescriptionPage="true"
        class="col-12 col-md-6 mb-4"
      />

      <div class="col-12">
        <SpinnerLoader v-if="isLoading" />

        <button
          @click="getJobs()"
          class="btn btn-wl-primary d-block mx-auto"
          v-if="!isLoading && !endResults"
        >
          Carregar mais
        </button>

        <div v-if="!isLoading && !opportunities.length">
          <p class="text-muted text-center">
            Nenhum resultado encontrado para esse filtro:
          </p>
          <FiltersBadges
            class="d-flex justify-content-center"
            :jobName="jobName"
            @resetJobName="
              jobName = null;
              typingJobName = null;
            "
            :selectedStates="selectedState ? [selectedState] : []"
            @resetState="selectedState = null"
            :selectedCities="selectedCity ? [selectedCity] : []"
            @resetCity="selectedCity = null"
            :selectedLevel="selectedLevel"
            @resetLevel="selectedLevel = null"
            :selectedPCD="selectedPCD"
            @resetPCD="selectedPCD = false"
            :selectedTeam="selectedTeam"
            @resetTeam="selectedTeam = null"
          />
        </div>

        <div v-if="!isLoading && opportunities.length && endResults">
          <p class="text-muted text-center">
            Todas as oportunidades foram listadas
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobBox from "ninenine-white-label/src/components/JobBox/JobBox.vue";
import FiltersBadges from "@/components/jobs/FiltersBadges.vue";
import SpinnerLoader from "ninenine-white-label/src/components/Loader/SpinnerLoader";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";

export default {
  name: "Jobs",

  data() {
    return {
      page: 0,
      endResults: false,
      isLoading: false,
      selectedState: null,
      selectedCity: null,
      selectedLevel: null,
      selectedPCD: false,
      selectedTeam: this.$route.query.area || null,
      typingJobName: null, // jobName enquanto digita
      jobName: null, // jobName após o enter

      stateSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },

      citySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",

        score: function scoreFilter(search) {
          var text = search.toString();
          var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
          var to = "aaaaaeeeeeiiiiooooouuuunc------";

          for (var i = 0, len = from.length; i < len; i++) {
            text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
          }

          var score = this.getScoreFunction(text);
          return function onScore(item) {
            var result = score(item);
            return result;
          };
        },
      },

      levelSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
    };
  },

  computed: {
    opportunities() {
      return this.$store.state.opportunities.all;
    },

    levels() {
      return this.$store.state.domains.professional_experience_levels || [];
    },

    states() {
      return this.$store.state.domains.states || [];
    },

    cities() {
      return this.$store.state.domains.cities || [];
    },

    teamInfos() {
      return (
        this.$store.state.teams.find(
          (team) => team.slug == this.selectedTeam
        ) || {}
      );
    },
  },

  watch: {
    selectedState: function (newValue, oldValue) {
      if (newValue) {
        this.getCities();
        this.clearFiltersAndGet();
      } else {
        this.$store.commit("location/ADD_CITIES", []);
        this.selectedCity = null;
      }
    },

    selectedCity: function (newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedLevel: function (newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedPCD: function (newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedTeam: function (newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    jobName: function (newValue, oldValue) {
      this.clearFiltersAndGet();
    },
  },

  components: {
    JobBox,
    FiltersBadges,
    SpinnerLoader,
    MagnifyIcon,
  },

  mounted() {
    // Remove o autofill para não atrabalhar o selectize
    setTimeout(() => this.removeAutoFillSelectize(), 500);

    // Busca as oportunidades
    if (
      this.$store.state.location.userLocation &&
      !this.selectedCity &&
      !this.selectedState
    ) {
      this.selectedState =
        this.$store.state.location.userLocation.subdivisions[0].iso_code;
      let city = this.$store.state.location.userLocation.city.names["pt-BR"];
      this.selectedCity = city
        ? this.$helpers.removeAccents(city).toUpperCase()
        : null;
      this.getCities();
    } else {
      this.clearFiltersAndGet();
    }

    // Busca os níveis possíveis para fazer o filtro de oportunidades
    if (this.$store.state.domains.professional_experience_levels.length == 0) {
      this.$store.dispatch(
        "graphql_queries/query",
        `domains { professionalExperienceLevels {id, name} }`
      );
    }
  },

  methods: {
    submitJobName() {
      this.jobName = this.typingJobName;
    },

    clearFiltersAndGet() {
      this.$store.commit("opportunities/CLEAR_OPPORTUNITIES");
      this.page = 0;
      this.endResults = false;
      this.getJobs();
    },

    async getJobs() {
      ++this.page;
      this.isLoading = true;

      let idStates = {
        AC: "2",
        AL: "3",
        AP: "4",
        AM: "5",
        BA: "6",
        CE: "7",
        DF: "8",
        ES: "9",
        GO: "10",
        MA: "11",
        MT: "12",
        MS: "13",
        MG: "14",
        PA: "15",
        PB: "16",
        PR: "17",
        PE: "18",
        PI: "19",
        RJ: "20",
        RN: "21",
        RS: "22",
        RO: "23",
        SC: "24",
        RR: "25",
        SP: "26",
        SE: "27",
        TO: "28",
      };

      let params = {
        collection: this.$helpers
          .cleanStringToCompare(this.teamInfos.slug)
          .replace(/ /g, "-"),
        page: this.page,
        pcd: this.selectedPCD,
        states: idStates[this.selectedState],
        city: this.selectedCity,
        level: this.selectedLevel,
        jobName: this.jobName,
      };

      const opportunities = await this.$store.dispatch(
        "opportunities/setOpportunities",
        params
      );
      this.endResults = opportunities.length < 20;
      this.isLoading = false;
    },

    getCities() {
      const params = {
        states: this.selectedState,
      };

      if (params.states && params.states.length > 0) {
        this.$store.dispatch("location/setCities", params);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 58px;
  &:before,
  &:after {
    content: "";
    width: auto;
    height: 4px;
    background: theme-color("wl-primary");
    flex-grow: 1;
    border-radius: 30px;
  }
  &:before {
    margin-right: 30px;
    @include media-breakpoint-down(md) {
      margin-right: 15px;
    }
  }
  &:after {
    margin-left: 30px;
    @include media-breakpoint-down(md) {
      margin-left: 15px;
    }
  }
}

/deep/ select.rounded-xl + .selectize-control {
  & > .selectize-input {
    border-radius: inherit;
  }
}
</style>